export default __webpack_public_path__ + "static/media/tecnotopia.73874729.svg";